// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.banner-wrapper {
  padding-top: 4px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 90%;
  margin-left: 5%;
  margin-top: 2%;
  gap: 0.4rem;
}
.banner-wrapper .banner-image-portrait {
  height: calc(var(--vh, 1vh) * 17.5);
  width: calc(var(--vw, 1vw) * 90);
  background-size: 100% 100%;
  background-repeat: no-repeat;
  background-position: center;
  border-radius: 10px;
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.2), 0 4px 8px rgba(0, 0, 0, 0.1);
}
@media (orientation: portrait) and (min-width: 768px) {
  .banner-wrapper .banner-image-portrait {
    width: 800px;
  }
}
@media (orientation: landscape) {
  .banner-wrapper .banner-image-portrait {
    display: none;
  }
}
.banner-wrapper .banner-image-landscape {
  display: none;
}
@media (orientation: landscape) {
  .banner-wrapper .banner-image-landscape {
    height: calc(var(--vw, 1vw) * 25);
    width: calc(var(--vh, 1vh) * 90);
    background-size: 100% 100%;
    background-repeat: no-repeat;
    background-position: center;
    overflow: hidden;
    border: 2px solid var(--ion-color-tertiary);
    border-radius: 5px;
    display: block;
  }
}
@media (orientation: landscape) and (min-width: 1024px) {
  .banner-wrapper .banner-image-landscape {
    width: 1150px;
  }
}
.banner-wrapper .banner-slider {
  padding-bottom: 4px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  gap: 0.6rem;
}
.banner-wrapper .banner-slider .dot {
  border-radius: 10px;
  background-color: #aaa;
  border: 4px solid #aaa;
}
.banner-wrapper .banner-slider .highlighted {
  border-radius: 10px;
  border: 4px solid #FFF;
}

.isAndroid {
  height: 135px !important;
  width: 106% !important;
}
@media (orientation: landscape) {
  .isAndroid {
    height: 110px !important;
    width: 106% !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/components/mobile/banner/banner.component.scss"],"names":[],"mappings":"AAAA;EACE,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EAEA,UAAA;EACA,eAAA;EACA,cAAA;EACA,WAAA;AAAF;AAEE;EACE,mCAAA;EACA,gCAAA;EAEA,0BAAA;EACA,4BAAA;EACA,2BAAA;EAUA,mBAAA;EACA,uEAAA;AAVJ;AAEI;EATF;IAUI,YAAA;EACJ;AACF;AAAI;EAZF;IAaI,aAAA;EAGJ;AACF;AAGE;EACE,aAAA;AADJ;AAEI;EAFF;IAGI,iCAAA;IACA,gCAAA;IACA,0BAAA;IACA,4BAAA;IACA,2BAAA;IACA,gBAAA;IACA,2CAAA;IACA,kBAAA;IACA,cAAA;EACJ;AACF;AACI;EAdF;IAeI,aAAA;EAEJ;AACF;AAAE;EACE,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;AAEJ;AADI;EACE,mBAAA;EACA,sBAAA;EACA,sBAAA;AAGN;AADI;EACE,mBAAA;EACA,sBAAA;AAGN;;AACA;EACE,wBAAA;EACA,sBAAA;AAEF;AADE;EAHF;IAII,wBAAA;IACA,sBAAA;EAIF;AACF","sourcesContent":[".banner-wrapper {\n  padding-top: 4px;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n\n  width: 90%;\n  margin-left: 5%;\n  margin-top: 2%;\n  gap: 0.4rem;\n\n  .banner-image-portrait {\n    height: calc(var(--vh, 1vh) * 17.5);\n    width: calc(var(--vw, 1vw) * 90);\n\n    background-size: 100% 100%;\n    background-repeat: no-repeat;\n    background-position: center;\n\n    //Tablet Portrait\n    @media (orientation: portrait) and (min-width: 768px) {\n      width: 800px;\n    }\n    @media (orientation: landscape) {\n      display: none;\n    }\n\n    border-radius: 10px;\n    box-shadow: 0 8px 16px rgba(0, 0, 0, 0.2), 0 4px 8px rgba(0, 0, 0, 0.1);\n  }\n\n  .banner-image-landscape {\n    display: none;\n    @media (orientation: landscape) {\n      height: calc(var(--vw, 1vw) * 25);\n      width: calc(var(--vh, 1vh) * 90);\n      background-size: 100% 100%;\n      background-repeat: no-repeat;\n      background-position: center;\n      overflow: hidden;\n      border: 2px solid var(--ion-color-tertiary);;\n      border-radius: 5px;\n      display: block;\n    }\n    //Tablet Landscape\n    @media (orientation: landscape) and (min-width: 1024px) {\n      width: 1150px;\n    }\n  }\n  .banner-slider {\n    padding-bottom: 4px;\n    display: flex;\n    flex-direction: row;\n    justify-content: center;\n    gap: 0.6rem;\n    .dot {\n      border-radius: 10px;\n      background-color: #aaa;\n      border: 4px solid #aaa;\n    }\n    .highlighted {\n      border-radius: 10px;\n      border: 4px solid #FFF;\n    }\n  }\n}\n.isAndroid {\n  height: 135px !important;\n  width: 106% !important;\n  @media (orientation: landscape) {\n    height: 110px !important;\n    width: 106% !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
